import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { formatDate } from '../../../constants/realVenueData';

export const useDatePicker = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [currentMonth, setCurrentMonth] = useState(new Date().getMonth());
  const [currentYear, setCurrentYear] = useState(new Date().getFullYear());

  const handleDateSelect = (dateObj, onDateChange) => {
    const day = dateObj.day || dateObj;
    const formattedDate = formatDate(day, currentMonth, currentYear);
    
    if (onDateChange) {
      onDateChange(formattedDate);
    }
    
    setShowDatePicker(false);
    
    const newSearchParams = new URLSearchParams(searchParams);
    newSearchParams.set('date', formattedDate);
    setSearchParams(newSearchParams);
  };

  const handleMonthChange = (direction) => {
    if (direction === 'next') {
      if (currentMonth === 11) {
        setCurrentMonth(0);
        setCurrentYear(prev => prev + 1);
      } else {
        setCurrentMonth(prev => prev + 1);
      }
    } else {
      if (currentMonth === 0) {
        setCurrentMonth(11);
        setCurrentYear(prev => prev - 1);
      } else {
        setCurrentMonth(prev => prev - 1);
      }
    }
  };

  return {
    showDatePicker,
    setShowDatePicker,
    currentMonth,
    currentYear,
    handleDateSelect,
    handleMonthChange
  };
};

